import { getApi } from '../apiClient';
import {
  IAgendaRange,
  IStudyPlan,
  IStudyPlanMeetings,
  tISODate,
  tStudyPlanId
} from './types';

// 404 means "this student has no study plan" — a normal state, not a failure, so it
// resolves instead of reaching the global error interceptor and its feedback log.
const isOkOrNoPlan = (status: number): boolean =>
  (status >= 200 && status < 300) || status === 404;

export async function getCurrentStudyPlan(): Promise<IStudyPlan | null> {
  const { data, status } = await getApi().get<IStudyPlan>('/study_plans/current', {
    validateStatus: isOkOrNoPlan
  });
  return status === 404 ? null : data;
}

export async function getAgendaRange(
  planId: tStudyPlanId,
  from: tISODate,
  to: tISODate
): Promise<IAgendaRange> {
  const { data } = await getApi().get<IAgendaRange>(
    `/study_plans/${planId}/agenda/range`,
    {
      params: { from, to }
    }
  );
  return data;
}

// Returns the whole week that holds `on`.
export async function getStudyPlanMeetings(
  planId: tStudyPlanId,
  on: tISODate
): Promise<IStudyPlanMeetings> {
  const { data } = await getApi().get<IStudyPlanMeetings>(
    `/study_plans/${planId}/meetings`,
    {
      params: { on }
    }
  );
  return data;
}
